type TOutput = {
  locale: string;
  country: string;
};

export const getUrlParams = (): TOutput => {
  const [country, locale] = window.location.pathname
    .replace('/about-portal', '')
    .split('/')
    .slice(1);

  return {
    locale: locale || 'ru',
    country: country || 'ru',
  };
};
